export default "__VITE_ASSET__D1dy7Hn0__"